// pages/PaymentCancel.jsx

import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, VStack, Heading, Text, Button, Alert, AlertIcon, Container } from '@chakra-ui/react';
import axios from 'axios';
import useToast from '../../../hooks/useToast';

const PaypalCancel = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { showInfoToast } = useToast();

  useEffect(() => {
    const handleCancellation = async () => {
      const token = searchParams.get('token');
      const invoiceId = searchParams.get('invoiceId');

      if (token && invoiceId) {
        try {
          // Notify backend about cancellation
          const params = new URLSearchParams({ token, invoiceId });

          await axios.get(
            `${process.env.REACT_APP_BASE_URL}/api/v1/payments/paypal/cancel?${params}`,
          );

          showInfoToast('Payment was cancelled');
        } catch (error) {
          console.error('Error handling payment cancellation:', error);
        }
      }
    };

    handleCancellation();
  }, [searchParams, showInfoToast]);

  return (
    <Container maxW="md" centerContent py={20}>
      <Box
        bg="white"
        p={8}
        borderRadius="xl"
        boxShadow="xl"
        border="2px solid"
        borderColor="orange.200"
        textAlign="center"
        w="100%"
      >
        <VStack spacing={6}>
          <Box fontSize="4xl">⚠️</Box>
          <Heading size="lg" color="orange.600">
            Payment Cancelled
          </Heading>
          <Alert status="warning" borderRadius="md">
            <AlertIcon />
            <Text fontSize="sm">Your PayPal payment was cancelled and no charges were made.</Text>
          </Alert>
          <Text color="gray.600">You can try again or choose a different payment method.</Text>
          <VStack spacing={3} w="100%">
            <Button colorScheme="blue" size="lg" onClick={() => window.history.back()} w="100%">
              Return to Invoice
            </Button>
            <Button variant="outline" size="lg" onClick={() => navigate('/')} w="100%">
              Return to Home
            </Button>
          </VStack>
        </VStack>
      </Box>
    </Container>
  );
};

export default PaypalCancel;
